import { useRef } from 'react';

// Tiny stand-in for React 18's useId(). Stable across renders, unique per
// component instance. Only used for ARIA wiring, never for SSR hydration
// (the SPA doesn't SSR).
let counter = 0;

export function useUniqueId(prefix = 'kk'): string {
  const ref = useRef<string | null>(null);
  if (ref.current === null) {
    counter += 1;
    ref.current = `${prefix}-${counter}`;
  }
  return ref.current;
}
